import { render, staticRenderFns } from "./indexContent.vue?vue&type=template&id=00200b84&"
import script from "./indexContent.vue?vue&type=script&lang=js&"
export * from "./indexContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports